/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TipoPraticaDocumentoDTO { 
    id?: string;
    nome_file?: string;
    descrizione?: string;
    size_bytes?: number;
    version?: number;
    created_at?: string;
}

